// ** IMPORTANT **: Keep in sync with functions/src/index.ts RESET_PASSWORD_CALLABLE_ERROR_CODE
// Frontend Firebase Functions SDK prefixes backend HttpsError codes with "functions/".
export enum RESET_PASSWORD_CALLABLE_ERROR_CODE {
    notFound = 'functions/not-found',
    failedPrecondition = 'functions/failed-precondition',
}
